import store from '@Store';

import { setStateCurrentType } from '@Constants/StateCurrent';

export function setStateCurrent(stateCurrent) {
  return {
    type: setStateCurrentType,
    stateCurrent,
  };
}

// Angular API method
export function dispatchSetStateCurrent(...args) {
  store.dispatch(setStateCurrent(...args));
}
